import script from "./ShipwreckDescription.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShipwreckDescription.vue?vue&type=script&lang=ts&setup=true"

import "./ShipwreckDescription.vue?vue&type=style&index=0&id=5b893418&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b893418"]])

export default __exports__